import Calendar from "../support/calendar/Calendar";
import styles from "./OrderCalendar.module.scss";

export default function OrderCalendar() {
  return (
    <div className={styles.container}>
      <Calendar
        className={styles.calendar}
        highlightedDatesLabel={"Order Days"}
        showLegend
      />
    </div>
  );
}
